<template>
  <div class="agent-profile-container" :style="cssVars()">
    <div class="custom-nav-block" :style="`padding-top: ${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span v-if="scene == '0'" class="tit-left">{{ $t('lang.AgentProfile.k002') }}</span>
          <span v-else class="tit-left">{{ $t('lang.AgentProfile.k006') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="page-content" :style="`margin-top: ${barHeight + 46}px`">
      <!-- Contact Card Section -->
      <div class="section-title">{{ $t('lang.AgentProfile.k003') }}</div>
      <div class="card contact-card">
        <!-- User Info Row -->
        <div class="user-info-row">
          <img v-if="selfContact.avatar" class="avatar-img" :src="selfContact.avatar | imgPath" alt="" />
          <div v-else class="avatar-placeholder"></div>
          <div class="user-detail">
            <div class="user-name">
              <span class="name-text">{{ selfContact.nickname }}</span>
              <span class="flag">
                <img :src="selfContact.locationFlagRound | imgPath" alt="" />
              </span>
            </div>
            <div class="user-id" @click="handleCopy(selfContact.presentId, $t('lang.BaseCommon.k071'))">
              <span>{{ $t('lang.AgentProfile.k004') }} {{ selfContact.presentId }}</span>
              <span class="copy-icon"></span>
            </div>
          </div>
        </div>

        <!-- WhatsApp Row -->
        <div class="contact-row" @click="handleEditContact">
          <span class="contact-label">{{ $t('lang.BaseCommon.k085') }}</span>
          <div class="contact-action">
            <span class="id-text" :class="{ 'id-add': !selfContact.whatsapp }">{{ selfContact.whatsapp || 'Add' }}</span>
            <span class="arrow-right"></span>
          </div>
        </div>

        <!-- Telegram Row -->
        <div class="contact-row" @click="handleEditContact">
          <span class="contact-label">{{ $t('lang.BaseCommon.k086') }}</span>
          <div class="contact-action">
            <span class="id-text" :class="{ 'id-add': !selfContact.telegram }">{{ selfContact.telegram || 'Add' }}</span>
            <span class="arrow-right"></span>
          </div>
        </div>

        <div v-if="scene === '1'" class="contact-tips hostess">{{ $t('lang.AgentProfile.k009') }}</div>
        <div v-if="scene === '0'" class="contact-tips agent">{{ $t('lang.AgentProfile.k010') }}</div>
      </div>

      <!-- My Hostes Section -->
      <div class="section-title my-hostes-title" v-if="scene == '0'">{{ $t('lang.AgentProfile.k001') }}</div>
      <div class="section-title my-hostes-title" v-else>{{ $t('lang.AgentProfile.k007') }}</div>
      <div class="hostes-list">
        <div class="card hostes-card" v-for="(item, index) in hostesList" :key="index">
          <van-image v-if="item.avatar" class="hostes-avatar-img" :src="item.avatar | imgPath" fit="cover" round lazy-load></van-image>
          <div class="hostes-info">
            <div class="user-name">
              <span class="name-text">{{ item.nickname }}</span>
              <span class="flag">
                <img :src="item.locationFlagRound | imgPath" alt="" />
              </span>
            </div>
            <div class="user-id" @click="handleCopy(item.presentId, $t('lang.BaseCommon.k071'))">
              <span>{{ $t('lang.AgentProfile.k004') }} {{ item.presentId }}</span>
              <span class="copy-icon"></span>
            </div>
          </div>
          <div class="hostes-actions">
            <div v-if="item.canSendContact" class="btn-send" @click="handleSendMessage(item)">
              <div class="icon-send"></div>
            </div>
            <div v-else class="btn-send" @click="handleSendMessage(item)">
              <div class="icon-send-disabled"></div>
            </div>
            <div v-if="item.hasContact" class="btn-profile" @click="handleViewProfile(item)">
              <div class="icon-profile"></div>
            </div>
          </div>
        </div>
      </div>

      <template v-if="scene != '1'">
        <div v-if="loading" class="is-loading">
          <van-loading size="24px" />
        </div>
        <div v-if="finished" class="no-more">{{ $t('lang.BaseCommon.k087') }}</div>
      </template>

      <div :style="{ height: `${bottomBarHeight + 82}px` }"></div>
    </div>

    <!-- View Contact Popup -->
    <van-popup v-model="showViewContact" round :style="{ background: 'transparent' }" :close-on-click-overlay="true">
      <div class="view-contact-container">
        <div class="view-contact-popup">
          <div class="view-contact-header">
            <div class="view-avatar-wrap">
              <img v-if="viewContact.avatar" class="view-avatar-img" :src="viewContact.avatar | imgPath" alt="" />
              <div v-else class="view-avatar-placeholder"></div>
            </div>

            <div class="view-user-info">
              <div class="view-user-name">
                <span class="name-text">{{ viewContact.nickname }}</span>
                <span class="flag">
                  <img :src="viewContact.locationFlagRound | imgPath" alt="" />
                </span>
              </div>
              <div class="view-user-id">
                <span>{{ $t('lang.AgentProfile.k004') }} {{ viewContact.presentId }}</span>
                <span class="copy-icon" @click="handleCopy(viewContact.presentId, $t('lang.BaseCommon.k071'))"></span>
              </div>
            </div>
          </div>

          <div class="view-contact-row">
            <span class="view-label">{{ $t('lang.BaseCommon.k085') }}</span>
            <div class="view-value">
              <span>{{ viewContact.whatsapp || '—' }}</span>
              <span v-if="viewContact.whatsapp" class="copy-icon" @click="handleCopy(viewContact.whatsapp, $t('lang.BaseCommon.k071'))"></span>
            </div>
          </div>

          <div class="view-contact-row">
            <span class="view-label">{{ $t('lang.BaseCommon.k086') }}</span>
            <div class="view-value">
              <span>{{ viewContact.telegram || '—' }}</span>
              <span v-if="viewContact.telegram" class="copy-icon" @click="handleCopy(viewContact.telegram, $t('lang.BaseCommon.k071'))"></span>
            </div>
          </div>

          <div class="popup-btn-ok active" @click="showViewContact = false">{{ $t('lang.BaseCommon.k088') }}</div>
        </div>
      </div>
    </van-popup>

    <!-- Edit Contact Popup -->
    <van-popup v-model="showEditContact" round :style="{ background: 'transparent' }" :close-on-click-overlay="true">
      <div class="edit-contact-container">
        <div class="edit-contact-popup">
          <div class="popup-title">{{ $t('lang.AgentProfile.k005') }}</div>

          <div class="popup-field">
            <span class="field-label">{{ $t('lang.BaseCommon.k085') }}</span>
            <input class="field-input" v-model.trim="editWhatsApp" maxlength="50" placeholder="" />
          </div>

          <div class="popup-field">
            <span class="field-label">{{ $t('lang.BaseCommon.k086') }}</span>
            <input class="field-input" v-model.trim="editTelegram" maxlength="50" placeholder="" />
          </div>

          <div class="popup-btn-ok" :class="{ active: isContactFilled }" @click="handleConfirmContact">{{ $t('lang.BaseCommon.k088') }}</div>
          <div class="popup-btn-cancel" @click="showEditContact = false">{{ $t('lang.BaseCommon.k006') }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getAllContactInfoApi, updateContactInfoApi, getContactInfoApi, sendContactInfoApi } from '@/api/invite.js'
import { pageCssVars } from './z-style-cfg.js'

export default {
  name: 'AgentProfile',
  mixins: [pageCssVars],
  data() {
    return {
      scene: this.$route.query.scene || '-1',
      // 自己
      selfContact: {
        avatar: '',
        nickname: '',
        presentId: '',
        telegram: '',
        uid: 0,
        whatsapp: '',
      },
      hostesList: [],
      listQuery: { offset: 0, limit: 10 },
      isIniting: false,
      loading: false,
      finished: false,
      lockLoad: false,
      // 编辑
      showEditContact: false,
      submitting: false,
      editWhatsApp: '',
      editTelegram: '',
      isSending: false,
      // 展示
      showViewContact: false,
      viewContact: {
        avatar: '',
        nickname: '',
        uid: 0,
        whatsapp: '',
        telegram: '',
      },
    }
  },
  computed: {
    isContactFilled() {
      return this.editWhatsApp.length > 0 || this.editTelegram.length > 0
    },
  },
  methods: {
    async fetchContactInfo() {
      this.listQuery.offset = 0
      this.finished = false
      this.hostesList = []
      this.isIniting = true

      try {
        const resData = await getAllContactInfoApi({
          uid: this.getUid(),
          scene: this.scene,
          offset: this.listQuery.offset,
          limit: this.listQuery.limit,
        })
        if (resData && !resData.error) {
          this.selfContact = resData.selfContact || this.selfContact
          const list = resData.memList || []
          this.hostesList = list
          this.listQuery.offset = list.length
          this.finished = list.length < this.listQuery.limit
        }
      } catch (e) {}

      this.isIniting = false
    },
    async loadMore() {
      if (this.loading || this.finished || this.isIniting) return
      this.loading = true
      try {
        const resData = await getAllContactInfoApi({
          uid: this.getUid(),
          scene: this.scene,
          offset: this.listQuery.offset,
          limit: this.listQuery.limit,
        })
        if (resData && !resData.error) {
          const list = resData.memList || []
          this.hostesList = this.hostesList.concat(list)
          this.listQuery.offset = this.hostesList.length
          this.finished = list.length < this.listQuery.limit
        }
      } catch (e) {}
      this.loading = false
      this.lockLoad = false
    },
    onScroll(event) {
      const clientH = document.documentElement.clientHeight
      const scrollH = document.body.scrollHeight
      const scrollT = event.target.scrollTop
      const distance = 5
      if (scrollT + clientH >= scrollH - distance) {
        if (!this.lockLoad) {
          this.lockLoad = true
          setTimeout(() => {
            this.loadMore()
          }, 100)
        }
      }
    },
    handleEditContact() {
      this.editWhatsApp = this.selfContact.whatsapp || ''
      this.editTelegram = this.selfContact.telegram || ''
      this.showEditContact = true
    },
    async handleConfirmContact() {
      if (!this.isContactFilled) return
      if (this.submitting) return
      this.submitting = true
      try {
        const resData = await updateContactInfoApi({
          telegram: this.editTelegram,
          whatsapp: this.editWhatsApp,
        })

        if (resData && !resData.error) {
          this.selfContact.whatsapp = this.editWhatsApp
          this.selfContact.telegram = this.editTelegram
          this.showEditContact = false
          this.$client.showToast(this.$t('lang.BaseCommon.k105'))
          this.fetchContactInfo()
        }
      } catch (e) {
        this.submitting = false
      } finally {
        this.submitting = false
      }
    },
    async handleSendMessage(item) {
      if (!item) return

      if (!this.selfContact.whatsapp && !this.selfContact.telegram) {
        this.$client.showToast(this.$t('lang.AgentProfile.k008'))
        return
      }

      if (this.isSending) return
      this.isSending = true

      try {
        const resData = await sendContactInfoApi({
          scene: this.scene,
          toUid: item.uid,
        })
        if (resData && !resData.error) {
          this.$client.showToast(this.$t('lang.BaseCommon.k105'))
        }
      } catch (e) {
        this.isSending = false
      } finally {
        this.isSending = false
      }
    },
    async handleViewProfile(item) {
      try {
        const resData = await getContactInfoApi({
          toUid: item.uid,
          scene: this.scene,
        })
        if (resData && !resData.error) {
          this.viewContact = resData
          this.showViewContact = true
        }
      } catch (e) {}
    },
  },
  created() {
    this.fetchContactInfo()
  },
  mounted() {
    document.body.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    document.body.removeEventListener('scroll', this.onScroll)
  },
}
</script>

<style lang="scss" scoped>
.agent-profile-container {
  width: 100%;
  min-height: 100vh;
  background-color: #f1f1fc;

  .custom-nav-block {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background-color: #f1f1fc;

    .left-nav {
      width: 20px;
      height: 20px;
      object-fit: contain;
    }
  }

  .page-content {
    padding: 20px 16px 0;
  }

  .section-title {
    color: #333333;
    font-family: 'InterTight-Regular';
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    margin-bottom: 16px;
  }

  .my-hostes-title {
    margin-top: 24px;
  }

  .card {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
  }

  // Contact Card
  .contact-card {
    padding: 16px 14px 20px;

    .user-info-row {
      display: flex;
      align-items: center;
      padding: 14px 0;

      .avatar-placeholder,
      .avatar-img {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background-color: #eaeaea;
        flex-shrink: 0;
        object-fit: cover;
      }

      .user-detail {
        margin: 0 12px;
        .user-name {
          .name-text {
            max-width: 190px;
          }
        }
      }
    }

    .contact-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px;

      border-radius: 8px;
      background: #f1f1fc;
      margin-bottom: 8px;

      .contact-label {
        font-size: 14px;
        color: #999;
      }

      .contact-action {
        display: flex;
        align-items: center;

        .id-text {
          font-size: 14px;
          color: #333333;
        }

        .id-add {
          color: #b2b2b2;
        }

        .arrow-right {
          width: 18px;
          height: 18px;
          transform: rotateZ(90deg);
          background: url('~@/assets/packageAssets/common/arrow08.png') left top / 100% 100% no-repeat;
        }
      }
    }

    .contact-tips {
      font-size: 13px;
      color: #333333;
      padding: 0 8px;
    }
  }

  // Shared user info styles
  .user-name {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 4px;

    .name-text {
      max-width: 130px;
      font-size: 15px;
      font-weight: 600;
      color: #333333;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .flag {
      width: 14px;
      height: 14px;
      border-radius: 50%;
      box-shadow: 0 0 1px 1px rgba(235, 235, 235, 0.9);
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .user-id {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #b2b2b2;

    .copy-icon {
      width: 16px;
      height: 16px;
      margin: 0 4px;
      background: url('~@/assets/packageAssets/views/P2_Page/AgentProfile/default/copy.png') left top / 100% auto no-repeat;
    }
  }

  .is-loading {
    display: flex;
    justify-content: center;
    padding: 16px 0 8px;
  }

  .no-more {
    padding-top: 10px;
    text-align: center;
    color: #b2b2b2;
    font-size: 16px;
  }

  // Hostes List
  .hostes-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .hostes-card {
    display: flex;
    align-items: center;
    padding: 16px 12px;

    .hostes-avatar-img {
      width: 48px;
      height: 48px;
      border-radius: 50%;
    }

    .hostes-info {
      flex: 1;
      margin: 0 12px;
    }

    .hostes-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-shrink: 0;

      .btn-send {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-color: #eeeef1;
        display: flex;
        align-items: center;
        justify-content: center;

        .icon-send {
          width: 20px;
          height: 20px;
          background: url('~@/assets/packageAssets/views/P2_Page/AgentProfile/default/send.png') left top / 100% auto no-repeat;
        }
        .icon-send-disabled {
          width: 20px;
          height: 20px;
          background: url('~@/assets/packageAssets/views/P2_Page/AgentProfile/default/send-disabled.png') left top / 100% auto no-repeat;
        }
      }

      .btn-profile {
        width: 36px;
        height: 36px;
        border-radius: 18px;
        background-color: #eeeef1;
        display: flex;
        align-items: center;
        justify-content: center;

        .icon-profile {
          width: 22px;
          height: 22px;
          background: url('~@/assets/packageAssets/views/P2_Page/AgentProfile/default/edit.png') left top / 100% auto no-repeat;
        }
      }
    }
  }
}

// View Contact Popup
.view-contact-container {
  width: 375px;
  padding: 0 30px;

  .view-contact-popup {
    background: #fff;
    border-radius: 12px;
    padding: 30px 16px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .view-contact-header {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 20px;

      .view-avatar-wrap {
        .view-avatar-placeholder,
        .view-avatar-img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background-color: #d0cdd8;
          object-fit: cover;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
        }
      }

      .view-user-info {
        padding: 0 10px;
        .view-user-name {
          display: flex;
          align-items: center;
          margin-bottom: 4px;

          .name-text {
            max-width: 190px;
            line-height: 19px;
            font-family: 'InterTight-Regular';
            font-size: 16px;
            font-weight: 600;
            color: #333333;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }

          .flag {
            width: 16px;
            height: 16px;
            margin: 0 4px;
            border-radius: 50%;
            box-shadow: 0 0 1px 1px rgba(235, 235, 235, 0.9);
            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .view-user-id {
          display: flex;
          align-items: center;
          font-size: 14px;
          line-height: 19px;
          color: #b2b2b2;

          .copy-icon {
            width: 16px;
            height: 16px;
            margin-left: 4px;
            background: url('~@/assets/packageAssets/views/P2_Page/AgentProfile/default/copy.png') left top / 100% auto no-repeat;
            cursor: pointer;
          }
        }
      }
    }

    .view-contact-row {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #f2f1f7;
      border-radius: 8px;
      padding: 12px;
      margin-bottom: 10px;

      .view-label {
        font-family: 'InterTight-Regular';
        font-size: 14px;
        color: #999999;
        white-space: nowrap;
        margin-right: 8px;
      }

      .view-value {
        display: flex;
        align-items: center;
        gap: 4px;
        font-family: 'InterTight-Regular';
        font-size: 14px;
        color: #333333;

        .copy-icon {
          width: 16px;
          height: 16px;
          background: url('~@/assets/packageAssets/views/P2_Page/AgentProfile/default/copy.png') left top / 100% auto no-repeat;
          cursor: pointer;
          flex-shrink: 0;
        }
      }
    }

    .popup-btn-ok {
      width: 100%;
      margin-top: 20px;
      padding: 13px 20px;
      border-radius: 25px;
      background: var(--agent-profile-btn-ok-bg);
      color: var(--agent-profile-btn-ok-color);
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: 'InterTight-Regular';
      font-size: 20px;
      font-weight: 400;
      line-height: 24px;
      cursor: pointer;
    }
  }
}

// Edit Contact Popup
.edit-contact-container {
  width: 375px;
  padding: 0 30px;
  .edit-contact-popup {
    background: #fff;
    border-radius: 12px;
    padding: 30px 16px;

    .popup-title {
      font-family: 'InterTight-Regular';
      font-size: 17px;
      font-weight: 500;
      color: #333333;
      text-align: center;
      margin-bottom: 24px;
    }

    .popup-field {
      display: flex;
      align-items: center;
      background: #f2f1f7;
      border-radius: 8px;
      padding: 12px;
      margin-bottom: 12px;

      .field-label {
        font-family: 'InterTight-Regular';
        font-size: 15px;
        color: #666666;
        font-weight: 500x;
        white-space: nowrap;
        margin-right: 10px;
      }

      .field-input {
        flex: 1;
        font-family: 'InterTight-Regular';
        font-size: 15px;
        color: #666666;
        background: transparent;
        border: none;
        outline: none;
      }
    }

    .popup-btn-ok {
      width: 100%;
      margin-top: 30px;
      padding: 13px 20px;
      border-radius: 25px;

      background: #cccccc;
      color: rgba(255, 255, 255, 0.4);

      display: flex;
      align-items: center;
      justify-content: center;

      font-family: 'InterTight-Regular';
      font-size: 20px;
      font-weight: 400;
      line-height: 24px;

      &.active {
        background: var(--agent-profile-btn-ok-bg);
        color: var(--agent-profile-btn-ok-color);
      }
    }

    .popup-btn-cancel {
      width: 100%;
      margin-top: 12px;
      padding: 13px 20px;
      border-radius: 25px;
      border: 1px solid var(--agent-profile-btn-cancel-border);
      color: var(--agent-profile-btn-cancel-color);

      display: flex;
      align-items: center;
      justify-content: center;

      font-family: 'InterTight-Regular';
      font-size: 20px;
      font-weight: 400;
      line-height: 24px;
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .agent-profile-container .contact-card .contact-row .contact-action .arrow-right {
    transform: rotateZ(-90deg);
  }
}
</style>
